module.exports = __webpack_public_path__ + "img/l-hd.3e548d1e.jpg";